import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { http } from './api'
import i18n from '@/locale'
import InfiniteLoading from 'vue-infinite-loading'

import './ui'
import '@/plugins'

Vue.use(http)
Vue.use(InfiniteLoading, {
  slots: { spinner: ' ' }
})

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
